<template>
  <div>
    <b-modal
      id="addattachment-modal"
      style="justify-content: space-around"
      hide-footer
      title="پیوست جدید"
    >
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form>
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-5"
              label="توضیحات: "
              label-for="input-5"
            >
              <b-form-textarea
                required
                id="input-5"
                v-model="Input.description"
                placeholder="توضیحات"
                rows="8"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="input-group-4"
              label="اضافه کردن پیوست: "
              label-for="input-4"
            >
              <fileUploader v-model="Input.file_id"></fileUploader>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-button
              style="width: 100%"
              variant="danger"
              @click="hideAddAttachmentModal"
              >بازگشت</b-button
            >
          </b-col>
          <b-col>
            <b-button
              style="width: 100%"
              variant="primary"
              @click="addAttachment"
              >ذخیره</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import fileUploader from "../../../components/fileUploader";
import httpHelper from "../../../helpers/httpHelper";

export default {
  name: "AddAttachment",
  components: {
    fileUploader,
  },
  props: ["afterdone", "customer_id"],
  data: function () {
    return {
      Input: {
        id: 0,
        description: "",
        file_id: "",
        customer_id: 0,
      },
      errors: [],
    };
  },
  watch: {
    "Input.file_id"(newValue, oldValue) {
        this.Input.file_id = newValue;
    }
  },
  methods: {
    hideAddAttachmentModal: function () {
      this.$bvModal.hide("addattachment-modal");
    },
    addAttachment: function () {
         this.errors = [];
      if (this.customer_id != null) {
        this.Input.customer_id = this.customer_id;
      }
      httpHelper.postData("crmattachment", this.Input).then((response) => {
        this.errors = [];
        if (response.success) {
          this.Input.description = "";
          this.Input.file_id = "";
          this.errors = [];
          this.afterdone();
          this.hideAddAttachmentModal();
        } else {
          for (var key in response.error) {
            response.error[key].forEach((element) => {
              this.errors.push(element);
            });
          }
        }
      });
    },

    showEdit: (card) => {
    },
  },
};
</script>
